import axios from "axios";
import { authURL } from "../config";

export const startSignInProcess = async body => {
  try {
    const response = await axios.post(`${authURL}signin`, body);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const checkAuth = async token => {
  try {
    const res = await axios.get(`${authURL}checkauth`, {
      headers: { authorization: token }
    });
    return res.data;
  } catch (err) {
    return err;
  }
};

export const createNewUser = async body => {
  const res = await axios.post(`${authURL}signup`, body);
  return res;
};

export const editProfile = async (id, data, token) => {
  try {
    const res = await axios.put(`${authURL}editProfile/${id}`, data, {
      headers: { authorization: token }
    });
    return res;
  } catch (err) {
    return err;
  }
};
